<template>
  <form
    :action="reverseFull({ name: 'change_flavour' })"
    method="post"
  >
    <input
      type="hidden"
      name="csrfmiddlewaretoken"
      :value="context.csrf_token"
    >
    <CoreAdminLink>
      <button type="submit">
        {{ text }}
      </button>
    </CoreAdminLink>
  </form>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import CoreAdminLink from 'src/core/CoreAdminLink/CoreAdminLink.vue'
import type { ContextStore } from 'src/layouts/core-layout/types'
import { useContextStore, useURLStore } from 'src/store'
import { translate } from 'src/layouts/core-layout/_functions/translate'

const { context }: ContextStore = useContextStore()
const { reverseFull } = useURLStore()

const isMobile = context.flavour === 'mobile'
const text = computed(() => (
  isMobile ? translate('Настольная версия') : translate('Мобильная версия')
))
</script>
